<template>
  <a role="row" :class="{ deleted: !component.alive }" :href="component.url">
    <div class="open22-file-item-container">
      <div class="open22-file-item">
        <div
          class="open22-table-cell c-title"
          :class="{ selected: selected === 'name' }"
        >
          <span class="icon" :class="component.icon"></span>
          <span class="text">{{ component.title }}</span>
          <span v-if="component.running" class="badge badge-running"
            >{{ $vt('Running') }}</span
          >
          <span
            v-if="component.active && !component.running"
            class="badge badge-active"
            >{{ $vt('Opened') }}</span
          >
        </div>

        <div
          class="open22-table-cell c-date"
          :class="{ selected: selected === 'date' }"
        >
          {{ datei18 }}
        </div>

        <div class="open22-table-cell c-type">
          {{ component.type }}
          <div class="open22-open-project-button">
            <f-button :type="['highlight', 'icon']">
              <f-icon icon="fa6-arrow-right"></f-icon>
            </f-button>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>
<script>
import { humanDate } from "../utils/dateUtils.mjs";

import Vue, { i18n } from '/vodalys/vvuejs/vue';

export default {
  translate25Context: "vconsole17_vue.open21",
  methods: {
    humanDate
  },
  props: ["component", "handler", "selected"],
  computed: {
    createImageBitmap() {
      return this.humanDate(this.component.created * 1000);
    },
    date() {
      return this.humanDate(this.component.created * 1000);
    },
    projectDate() {
      return this.component.date && this.humanDate(this.component.date * 1000, true);
    },
    datei18() {

      const ts = this.component.date ?? this.component.created;

      return this.humanDate(ts * 1000, true, this.locale);
    },
    locale() {
      return i18n?.locale ?? 'fr';
    },
  },
  mounted() {},
};
</script>